import * as React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import BaseSceneCommandModal from './BaseSceneCommandModal';

import SoundEffectView from './visualizations/SoundEffectView';

import DeleteButton from './buttons/DeleteButton';
import ChangeButton from './buttons/ChangeButton';

import CompositeSequenceSceneCommandFormFactory from '../../../../../view_models/CompositeSequenceSceneCommandFormFactory';

import SceneCommandForm from '../../../../../../domain/forms/scene_commands/SceneCommandForm';
import BackgroundMusicShowSceneCommandForm from '../../../../../../domain/forms/scene_commands/BackgroundMusicShowSceneCommandForm';

interface Props {
  sceneCommandForm: BackgroundMusicShowSceneCommandForm;
  parentSceneCommandForm?: SceneCommandForm | null;
  onRequestCloseModal: () => void;
  onForwardToChangeBackgroundMusic: (
    sceneCommandForm: BackgroundMusicShowSceneCommandForm,
    parentSceneCommandId?: number,
  ) => void;
  onRemoveBackgroundMusicShowCommand: (
    sceneCommandForm: BackgroundMusicShowSceneCommandForm,
  ) => void;
  onChangeCommand: (sceneCommandForm: SceneCommandForm) => void;
  onRemoveCommand: (sceneCommandForm: SceneCommandForm) => void;
}

export default class BackgroundMusicShowSceneCommandModal extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    const {sceneCommandForm, onRequestCloseModal} = this.props;
    return (
      <BaseSceneCommandModal
        title={'BGMの編集'}
        onRequestCloseModal={onRequestCloseModal}
        footer={
          <View style={styles.footer}>
            <View style={styles.deleteButtons}>
              <DeleteButton onPress={this.destroySceneCommandForm} />
            </View>
          </View>
        }>
        <View style={styles.body}>
          <View
            style={{
              flex: 1,
              width: '100%',
              flexDirection: 'column',
              alignItems: 'flex-end',
              paddingHorizontal: 32,
              marginVertical: 4,
            }}>
            <ChangeButton title={'BGM変更'} onPress={this.changeEffect} />
          </View>

          <SoundEffectView sound={sceneCommandForm.sound} />
        </View>
      </BaseSceneCommandModal>
    );
  }

  private changeEffect = () => {
    const {
      sceneCommandForm,
      parentSceneCommandForm,
      onRequestCloseModal,
      onForwardToChangeBackgroundMusic,
    } = this.props;
    onForwardToChangeBackgroundMusic(
      sceneCommandForm,
      parentSceneCommandForm?.sceneCommandId,
    );
    onRequestCloseModal();
  };

  private destroySceneCommandForm = () => {
    const {
      sceneCommandForm,
      parentSceneCommandForm,
      onRequestCloseModal,
      onRemoveBackgroundMusicShowCommand,
      onChangeCommand,
      onRemoveCommand,
    } = this.props;
    if (parentSceneCommandForm) {
      const newParentSceneCommandForm =
        CompositeSequenceSceneCommandFormFactory.remove(
          parentSceneCommandForm,
          sceneCommandForm,
        );
      if (newParentSceneCommandForm) {
        onChangeCommand(newParentSceneCommandForm);
      } else {
        onRemoveCommand(parentSceneCommandForm);
      }
    } else {
      onRemoveBackgroundMusicShowCommand(sceneCommandForm);
    }
    onRequestCloseModal();
  };
}

const styles = StyleSheet.create({
  body: {
    backgroundColor: '#fafafa',
    alignItems: 'center',
    width: '100%',
  } as ViewStyle,
  button: {
    marginVertical: 5,
  } as ViewStyle,
  deleteButtons: {
    marginTop: 5,
  } as ViewStyle,
  footer: {
    padding: 10,
  } as ViewStyle,
});
